import type { DateTime } from 'luxon'

export enum FilterIntervalName {
  OneWeek = '1w',
  ThreeMonths = '3m',
  SixMonths = '6m',
  SinceStart = 'start',
}

export interface FilterInterval {
  name: FilterIntervalName
  start: DateTime
  end: DateTime
}
